import api from 'api'
import { previewFile } from 'util/previewFile'

export const visualizarArquivoAnexado = (arquivoUuid: string) => {
  return api.anexoArquivos.baixarArquivo(arquivoUuid).then((response) => {
    previewFile(new Blob([response.data], { type: response.headers['content-type'] as string }), 'Arquivo Anexado')
  })
}
